const PolyMeshProperties = {
  schema: {
    // Note: right now we use double-sided rendering by default in threehub. This property is currently
    // used only to set the appropriate value in the V2 importers for export back to V1
    doubleSided: { label: 'Double Sided', type: 'Boolean', defaultValue: false },
    visible: { label: 'Visible', type: 'Boolean', defaultValue: true, animatable: true },
    prefetch: { label: 'Pre-fetch mesh', type: 'Boolean', defaultValue: false },
  },
};

const MaterialProperties = {
  schema: {
    prefetch: { label: 'Pre-fetch Material', type: 'Boolean', defaultValue: false },
  },
};

const ImageProperties = {
  schema: {
    prefetch: { label: 'Pre-fetch Image', type: 'Boolean', defaultValue: false },
  },
};

const Default = {
  schema: {
    visible: { label: 'Visible', type: 'Boolean', defaultValue: true, animatable: true },
  },
};


const motionTypes = ['Static', 'Kinematic', 'Dynamic'];
const shapeValues = ['Box', 'Convex', 'Mesh'];
const shapeLabels = ['Bounding Box', 'Convex Hull', 'Mesh (Non-Dynamic)'];

const RigidBodyProperties = {
  schema: {
    collisionShape: {
      label: 'Collision Shape',
      type: 'Options',
      display: 'Dropdown',
      values: shapeValues,
      labels: shapeLabels,
      defaultValue: 'Convex',
    },
    motionType: {
      label: 'Motion Type',
      type: 'Options',
      display: 'Dropdown',
      values: motionTypes,
      labels: motionTypes,
      defaultValue: 'Dynamic',
    },
    mass: { label: 'Mass', type: 'Number', defaultValue: 1.0, minValue: 0.0, step: 1 },
    linearDamping: { label: 'Linear Damping', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 1.0, step: 0.1 },
    angularDamping: { label: 'Angular Damping', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 1.0, step: 0.1 },
 //   gravity: { label: 'Local Gravity', type: 'Vec3', step: 1.0, defaultValue: [0, -9.8, 0] },
    linearFactor: { label: 'Linear Factor', type: 'Vec3', defaultValue: [1.0, 1.0, 1.0] },
    angularFactor: { label: 'Angular Factor', type: 'Vec3', defaultValue: [1.0, 1.0, 1.0] },
    linearVelocity: { label: 'Linear Velocity', type: 'Vec3', defaultValue: [0.0, 0.0, 0.0] },
    angularVelocity: { label: 'Angular Velocity', type: 'Vec3', defaultValue: [0.0, 0.0, 0.0] },
    linearSleepingThreshold: { label: 'Linear Sleep Threshold', type: 'Number', defaultValue: 0.8, minValue: 0.0, step: 0.1 },
    angularSleepingThreshold: { label: 'Angular Sleep Threshold', type: 'Number', defaultValue: 1.0, minValue: 0.0, step: 0.1 },
    friction: { label: 'Friction', type: 'Number', defaultValue: 0.5, minValue: 0.0, step: 0.1 },
    rollingFriction: { label: 'Rolling Friction', type: 'Number', defaultValue: 0.0, minValue: 0.0, step: 0.1 },
    restitution: { label: 'Bounce', type: 'Number', defaultValue: 0.0, minValue: 0.0, maxValue: 1.0, step: 0.1 },
  },
};

export default {
  Default,
  PolyMeshProperties,
  MaterialProperties,
  ImageProperties,
  RigidBodyProperties,
};



// WEBPACK FOOTER //
// ./src/operators/Properties.js